import { createStore } from 'vuex'
import auth from './modules/auth'
import categories from './modules/categories'
import questions from './modules/questions'
import documentation from './modules/documentation'
import conversations from './modules/conversations'
import notifications from './modules/notifications'
import users from './modules/users'
import dashboard from './modules/dashboard'

export default createStore({
  modules: {
    auth,
    categories,
    questions,
    documentation,
    conversations,
    notifications,
    users,
    dashboard
  },
  state: {
    loading: false,
    error: null
  },
  mutations: {
    SET_LOADING(state, loading) {
      state.loading = loading
    },
    SET_ERROR(state, error) {
      state.error = error
    }
  },
  actions: {
    setLoading({ commit }, loading) {
      commit('SET_LOADING', loading)
    },
    setError({ commit }, error) {
      commit('SET_ERROR', error)
    },
    clearError({ commit }) {
      commit('SET_ERROR', null)
    }
  },
  getters: {
    isLoading: state => state.loading,
    error: state => state.error
  }
}) 